export const MAX_CHARACTERS = 15;
export const MAX_TAGS = 6;
export const MIN_TAGS = 1;

export const TAG_PREFIX = '#';
export const TAG_SUGGESTIONS = [
  '#health',
  '#LGBTQ+',
  '#beauty',
  '#fitness',
  '#comedy',
  '#travel',
  '#games',
  '#dance',
];
